import React from "react";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
const BackButton = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <p className="back-btn-bold" onClick={goBack}>
      <MdKeyboardArrowLeft className="arrow-left" />
      Back
    </p>
  );
};
export default BackButton;
